import format from 'date-fns/format';
import { map } from 'lodash';
import { createAction } from 'redux-actions';
import { CALL_API } from '../constants';
import { fromAddressResponse } from '../util';

const toPatient = (data = {}) => {
  return {
    ...fromAddressResponse(data.address),
    birthday: data.birthday
      ? format(data.birthday, 'YYYY-MM-DD')
      : data.birthday,
    firstName: data.firstName,
    additionalNotes: data.additionalNotes,
    notes: data.notes,
    gender: data.gender,
    id: data.id,
    lastName: data.lastName,
    userId: data.userId,
  };
};

const PatientService = {
  getByUserId: createAction(CALL_API, id => ({
    method: 'GET',
    path: `/patients/user/${id}`,
    handleResponse: patients => map(patients, toPatient),
    handleError: () =>
      Promise.reject(
        'Patient information could not be loaded. Please refresh to try again.',
      ),
  })),

  update: createAction(CALL_API, ({ id, patient }) => ({
    body: patient,
    method: 'PUT',
    path: `/patients/${id}`,
    handleError: () =>
      Promise.reject(
        'We were unable to update your patient information. Please try again.',
      ),
  })),
};

export default PatientService;



// WEBPACK FOOTER //
// ./src/lib/dataLayer/patient/PatientService.js